export const baseApiUrl = import.meta.env.VITE_API_BASE_URL;

export const aiBaseApiUrl = import.meta.env.VITE_AI_API_BASE_URL;

export const baseAutomationUrl = import.meta.env.VITE_AUTOMATION_BASE_URL;

export const secretKey = import.meta.env.VITE_THERAPIST_SECRET_KEY;

export const keycloakAuthUrl = import.meta.env.VITE_KEYCLOAK_AUTH_URL;

export const splitIoAuthorizationKey = import.meta.env.VITE_SPLIT_IO_KEY;

export const serviceLogMatrixVisibilityTreatment = 'Service-Log-Matrix-visibility';

export const goalBankTreatment = 'THIN-4032_goal_bank';

// BRK-1842 MDS Dashboard master kill switch (facility-keyed)
export const mdsDashboardNewTreatment = 'mds-dashboard-new';

// BRK-1859/1860 independent MDS worksheet print kill switch (facility-keyed)
export const mdsDashboardPrintNewTreatment = 'mds-dashboard-print-new';

// BRK-1963/1967 PDPM CMG estimator kill switch (facility-keyed); rollback is
// flag-off — the estimate endpoint is read-only, so there is nothing to migrate
export const pdpmCmgEstimatorNewTreatment = 'pdpm-cmg-estimator-new';

export const deleteDocumentAlertTreatment = 'THIN-4275-delete-document-alert';

export const autoProgressNoteTreatment = 'THIN-4366-auto-progress-note';

export const prefillIdCPTICDTreatment = 'THIN-4371-add-prefillId-CPT-ICD-edit-document';

export const copyCodeDescriptionTreatment = 'THIN-4080-copy-description';

export const clockInActivityType = 'THIN-4807-activity-type';

export const isSchedularUIImprovement = 'THIN-4807-scheduler-ui-improvement';

export const reformUsePhysicianTableV2 = 'Reform-use-physician-table-version';

export const therapyPlanning2_0 = 'THIN-4421-therapy-planning-2';

export const therapyPlanningTemplate = 'THIN-5285-therapy-templates';

export const recheckDischarge = 'THIN-5585-recheck-discharge';

export const DocDuePnAlert = 'docs-due-fsm';

export const therapistBulkSignature = 'THIN-5700-bulk-signature-for-therapists';

export const excludes1WarnTreatment = 'BRK-1686-excludes1-warning';

export const dorEditCodesTreatment = 'dor-edit-codes';

export const reformDsnAiTreatment = 'Reform-DSN-AI';

export const reformWpnAiTreatment = 'Reform-PN-AI';

export const profilityAiTreatment = 'profility-data-processing';

export const goalBuilder = 'goal-builder';

export const goalBuilderOt = 'goal-builder-ot';

export const goalBuilderPtAmbulation = 'goal-builder-pt-ambulation';

export const isSplitMinEnabled = 'THIN-5961-Split-Treatment-Functionality';

export const thoughtSpotUrl = import.meta.env.VITE_THOUGHT_SPOT_URL;

export const thoughtSpotApiUrl = import.meta.env.VITE_THOUGHT_SPOT_API_URL;

export const codesApiUrl = import.meta.env.VITE_CODES_API_URL || undefined;

export const codesApiSecurityCode = import.meta.env.VITE_CODES_API_SECURITY_CODE || undefined;

export const supervisory_10th_visit_alert = 'THIN-6026-10th-visit-supervisory-alert';

export const reportsDownloadUB04 = 'Reports-Download-UB04';

export const reportsDownloadCensusDetails = 'Reports-Download-Census_Details';

export const reportsDownloadMDSAssessmentDetails = 'Reports-Download-MDS_Assessment_Details';

export const reportsDownloadDailyCensus = 'Reports-Download-Daily_Census';

export const documentBundleDownload = 'SQ-64-Document-Bundle-Download';

export const signOnBehalf = 'THIN-5621-sign-on-behalf-option-for-DORs';
//  BRK-2056/BRK-2059: one ENTERPRISE-keyed onboarding lever for the compliance on-behalf
//  capability — the same Split that surfaces the permission rows in the enterprise portal
//  (provider-service FeatureConstants.COMPLIANCE_ON_BEHALF). Gates the FE affordance only;
//  the backend's authorization is the permission grant itself, never this flag.
export const complianceOnBehalf = 'provider_portal_compliance_on_behalf';

export const slpEvalReformOAMigrationTreatment = 'SLP-eval-Objective-Assessment-Migration';

export const ptRecertReformOAMigrationTreatment = 'PT-recert-Objective-Assessment-Migration';

export const patientInfoMissingCheck = 'patient-info-missing';

export const multiPayerFlag = 'multipayer-patient-payer';

export const appointmentBookFlag = 'THIN-6356-appointment-book';

export const inactiveUserTimeoutTreatment = 'inactive-user-timeout-popup';

export const recurringAppointmentBookFlag = 'THIN-6683-recurring-appointments';

export const icd10ReturnToProvider = 'icd10-return-to-provider';

// BRK-2170: DSN units from reform's ODIE-parity engine (BRK-2169), per facility
export const dsnUnitEngineV2 = 'dsn-unit-engine-v2';

export const isPlannerPastDaysEditable = 'THIN-7001-planner-past-days-editable';

export const thoughtSpotAuthType = 'ThoughtSpot-AuthType-TrustedAuthTokenCookieless';

//  THIN-7799: gates the DSN hard-delete affordances. Same treatment name and
//  ENTERPRISE split key that frontend-portal uses to gate the "Delete Daily
//  Notes" permission out of Roles & Permissions, so both portals flip together.
export const dsnDeletePermissionTreatment = 'THIN-7799-dsn-delete-permission';
export const holdFromBillingTreatment = 'provider_portal_hold_from_billing';

export const prelimInvoiceReviewTreatment = 'provider_portal_preliminary_invoice_review';

export const archiveDailyNoteTreatment = 'provider_portal_archive_daily_note';

export const billingExportDownloadTreatment = 'provider_portal_billing_export_download';

//  Also gates the BOPS-118 Sign Certification redesign on the frontend: the backend's own
//  `closeout-signed_by` treatment isn't resolvable from the browser, and the two ship together.
export const customCloseoutTreatment = 'provider_portal_custom_closeout';

export const therapyPlanningCaseMixTemplates = 'THIN-7679-planning-case-mix-templates';
//  THIN-7737: gates the NPC Log (Non-Patient Care time tracking) tab, shown
//  beside Labor Hour Management under Actions → Labor Management. Facility-keyed.
export const npcLogTreatment = 'THIN-7737-npc-log';

//  BOPS-126: gates the "Treatment but No Labor" (MISSING_LABOR_LOG) alert. Same ENTERPRISE
//  split key the backend uses (provider_portal_treatment_but_no_labor); on the frontend it also
//  gates the per-row Refresh action shown on those alerts when they are set to Error.
export const treatmentButNoLaborTreatment = 'provider_portal_treatment_but_no_labor';

//  BOPS-431 to BOPS-435: the billing blocker alerts. Same ENTERPRISE split key the backend gates
//  them on; with it on, their Closeout Alerts row shows an info icon and the fix guidance.
export const billingBlockerAlertsTreatment = 'provider_portal_billing_blocker_alerts';

//  BOPS-209: the same dark-launch flag the Enterprise Portal's RBAC gating rides. Passed down to
//  @restore/rebill, which locks its own routes and actions (ADR-013) and fails open until it is on.
export const enterpriseRbacEnforcementTreatment = 'THIN-7842-enterprise-rbac-enforcement';

//  RA-2027: gates the Labor section of Report Downloads and the quarterly CMS Payroll-Based
//  Journal (PBJ) export card inside it. ENTERPRISE-keyed like the other three Report Downloads
//  treatments; default off — when off the whole Labor section is absent, not an empty heading.
export const reportsDownloadPBJ = 'Reports-Download-PBJ';

//  BRK-2028: gates the whole Document Revision History Audit feature — the two Completed
//  Documents kebab items here, provider-service's per-row flag pass, and document-service's
//  generate endpoint all read this one treatment. FACILITY-keyed, default OFF; flag off is
//  exact pre-feature behavior and rollback is just the flag.
export const documentRevisionAuditTreatment = 'document-revision-audit';

//  THIN-8288: provider-service's docs-due-anchored-mode (FeatureConstants.DOCS_DUE_ANCHORED_MODE).
//  FACILITY-keyed. On, Docs Due applies a payer's rules from the day it is entered, so the payer
//  form says so for backdated payers; off, the whole cycle recalculates and the note stays hidden.
export const docsDueAnchoredModeTreatment = 'docs-due-anchored-mode';
